const addOnsSettings = {
  unsubscribed: 0,
  subscribed: 1,
  interested: 2,
};

export default addOnsSettings;
